import { Log } from './log/Log.js';
export const log = new Log('PDR');